/* eslint-disable no-unused-vars */
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import s from './index.module.scss';

function Chart ({ container, gainWeight }) {
	const currentStep = useSelector((state) => state.steps.currentStep);
	const pathToAnimate = useRef(null);
	const circle1 = useRef(null);
	const circle2 = useRef(null);
	const circle3 = useRef(null);

	function setVaribles () {
		const scaleFactor = container.current.getBoundingClientRect().width / 335;

		container.current.style.setProperty('--pathLength', pathToAnimate.current.getTotalLength().toFixed(2));

		container.current.style.setProperty('--circle1X', circle1.current.getBBox().x * scaleFactor + circle1.current.getBBox().width * scaleFactor / 2);
		container.current.style.setProperty('--circle1Y', circle1.current.getBBox().y * scaleFactor - circle1.current.getBBox().height * scaleFactor / 2);

		container.current.style.setProperty('--circle2X', circle2.current.getBBox().x * scaleFactor + circle2.current.getBBox().width * scaleFactor / 2);
		container.current.style.setProperty('--circle2Y', circle2.current.getBBox().y * scaleFactor - circle2.current.getBBox().height * scaleFactor / 2);

		container.current.style.setProperty('--circle3X', circle3.current.getBBox().x * scaleFactor + circle3.current.getBBox().width * scaleFactor / 2);
		container.current.style.setProperty('--circle3Y', circle3.current.getBBox().y * scaleFactor - circle3.current.getBBox().height * scaleFactor / 2);
	}

	useEffect(() => {
		setVaribles();
		window.addEventListener('resize', setVaribles);

		return () => {
			window.removeEventListener('resize', setVaribles);
		};
	}, []);

	useEffect(() => {
		setVaribles();
	}, [currentStep]);

	if (gainWeight) {
		return (
			<svg preserveAspectRatio="none" className={s.svg} viewBox="0 0 335 205" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M0 7.99C0 3.57 3.582 0 8 0h319a8 8 0 0 1 8 8v189a8 8 0 0 1-8 8H8c-4.418 0-8-3.572-8-7.99V7.989Z" fill="url(#a)" />
				<mask id="c" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="335" height="205">
					<path d="M0 4.987A4.989 4.989 0 0 1 5 0h325a5 5 0 0 1 5 5v195a5 5 0 0 1-5 5H5a4.99 4.99 0 0 1-5-4.987V4.986Z" fill="url(#b)" />
				</mask>
				<g mask="url(#c)">
					<path d="M336 47.5C167 47.5 159 162-.5 162v44l336.5 5V47.5Z" fill="url(#e)" />
					<path className={s.pathToAnimate} ref={pathToAnimate} d="M-.5 162C159 162 167 47.5 336 47.5" stroke="url(#d)" strokeWidth="2.5" />
				</g>
				<circle className={s.animation3} ref={circle3} cx="288" cy="51" r="4" fill="#18D29A" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
				<circle className={s.animation1} ref={circle1} cx="46" cy="158" r="4" fill="#FF7659" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
				<circle className={s.animation2} ref={circle2} cx="165" cy="104" r="4" fill="#FFA337" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
				<defs>
					<linearGradient id="a" x1="167.5" y1="-102.5" x2="-15.04" y2="195.797" gradientUnits="userSpaceOnUse">
						<stop stopColor="#8874E6" />
						<stop offset="1" stopColor="#754ACB" />
					</linearGradient>
					<linearGradient id="b" x1="300.751" y1="-55.734" x2="-15.615" y2="210.755" gradientUnits="userSpaceOnUse">
						<stop stopColor="#806BE3" />
						<stop offset="1" stopColor="#7E69E3" />
					</linearGradient>
					<linearGradient id="d" x1="40.5" y1="90.5" x2="331" y2="179" gradientUnits="userSpaceOnUse">
						<stop stopColor="#FFAB5A" />
						<stop offset=".422" stopColor="#FFEB5A" />
						<stop offset="1" stopColor="#21EBBA" />
					</linearGradient>
					<linearGradient id="e" x1="165.5" y1="-156.187" x2="165.5" y2="200" gradientUnits="userSpaceOnUse">
						<stop stopColor="#fff" />
						<stop offset="1" stopColor="#957FFB" />
					</linearGradient>
					<linearGradient id="f" x1="40.5" y1="90.5" x2="331" y2="179" gradientUnits="userSpaceOnUse">
						<stop stopColor="#FFAB5A" />
						<stop offset=".422" stopColor="#FFEB5A" />
						<stop offset="1" stopColor="#21EBBA" />
					</linearGradient>
				</defs>
			</svg>
		);
	}

	return (
		<svg preserveAspectRatio="none" className={s.svg} viewBox="0 0 335 205" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0 7.99C0 3.57 3.582 0 8 0h319a8 8 0 0 1 8 8v189a8 8 0 0 1-8 8H8c-4.418 0-8-3.572-8-7.99V7.989Z" fill="url(#a)" />
			<mask id="c" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="335" height="205">
				<path d="M0 4.987A4.989 4.989 0 0 1 5 0h325a5 5 0 0 1 5 5v195a5 5 0 0 1-5 5H5a4.99 4.99 0 0 1-5-4.987V4.986Z" fill="url(#b)" />
			</mask>
			<g mask="url(#c)">
				<path d="M336 156.189C117.5 156.189 117 47.5-4 47.5V211h340v-54.811Z" fill="url(#d)" />
				<path className={s.pathToAnimate} ref={pathToAnimate} d="M-4 47.5C117 47.5 117.5 156.189 336 156.189" stroke="url(#e)" strokeWidth="2.5" />
			</g>
			<circle className={s.animation3} ref={circle3} cx="287" cy="155" r="4" fill="#18D29A" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
			<circle className={s.animation1} ref={circle1} cx="45" cy="54" r="4" fill="#FF7659" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
			<circle className={s.animation2} ref={circle2} cx="164" cy="121" r="4" fill="#FFA337" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
			<defs>
				<linearGradient id="a" x1="167.5" y1="-102.5" x2="-15.04" y2="195.797" gradientUnits="userSpaceOnUse">
					<stop stopColor="#8874E6" />
					<stop offset="1" stopColor="#754ACB" />
				</linearGradient>
				<linearGradient id="b" x1="300.751" y1="-55.734" x2="-15.615" y2="210.755" gradientUnits="userSpaceOnUse">
					<stop stopColor="#806BE3" />
					<stop offset="1" stopColor="#7E69E3" />
				</linearGradient>
				<linearGradient id="d" x1="165.5" y1="-156.187" x2="165.5" y2="200" gradientUnits="userSpaceOnUse">
					<stop stopColor="#fff" />
					<stop offset="1" stopColor="#957FFB" />
				</linearGradient>
				<linearGradient id="e" x1="40.5" y1="90.5" x2="331" y2="179" gradientUnits="userSpaceOnUse">
					<stop stopColor="#FFAB5A" />
					<stop offset=".422" stopColor="#FFEB5A" />
					<stop offset="1" stopColor="#21EBBA" />
				</linearGradient>
			</defs>
		</svg>
	);
}

function BodyMass (props) {
	const { T } = useT();
	const container = useRef(null);
	const description = T('see_results', { duration: props.duration });

	return (
		<div className={`${s.bodyMass} ${props.gainWeight ? s.gainWeight : ''} ${props.animate ? s.animate : ''}`}>
			<div className={s.container} ref={container}>
				<div className={s.description}>{description}</div>

				<Chart container={container} gainWeight={props.gainWeight} />

				<div className={`${s.weight} ${s.weight1} ${s.animation1}`}>
					{props.currentWeightToShow}
          &nbsp;
					{props.currentUnitsToShow}
				</div>
				<div className={`${s.weight} ${s.weight2} ${s.animation2}`}>
					{props.intermediateWeight}
          &nbsp;
					{props.targetWeightUnits}
				</div>
				<div className={`${s.weight} ${s.weight3} ${s.animation3}`}>
					{props.targetWeight}
          &nbsp;
					{props.targetWeightUnits}
				</div>

				<div className={s.dates}>
					<div className={`${s.date} ${s.date1} ${s.animation1}`}>{props.dateFirst}</div>
					<div className={`${s.date} ${s.date2} ${s.animation2}`}>{props.dateSecond}</div>
					<div className={`${s.date} ${s.date3} ${s.animation3}`}>{props.dateThird}</div>
				</div>
			</div>
		</div>
	);
}

export default BodyMass;
